// login
export const STRINGS_LOGIN = "Login";
export const STRINGS_EMAIL = "Email";
export const STRINGS_PASSWORD = "Password";
export const STRINGS_EMAIL_NOT_VALID = "Email not valid";
export const STRINGS_EMAIL_REQUIRED = "Email is required";
export const STRINGS_PASSWORD_REQUIRED = "Password is required";
export const STRINGS_CANCEl = "Cancel";
export const STRINGS_OK = "Ok";

// home
export const STRINGS_LOGOUT = "Logout";
export const STRINGS_USERS = "Users";
export const STRINGS_ACTIONS = "Actions";
export const STRINGS_CATEGORIES = "Categories";
export const STRINGS_PRODUCTS = "Products";
export const STRINGS_ADMIN_PANEL = "Admin Panel";
export const STRINGS_NOTHING_TO_SHOW = "Nothing to show";

// users
export const STRINGS_SEARCH = "Search";
export const STRINGS_USER_MANAGEMENT = "Users Management";
export const STRINGS_MANAGE = "Manage";
export const STRINGS_PLAYED_AT = "Played at";
export const STRINGS_SELECTED_CATEGORIES = "Selected Categories";
export const STRINGS_STATS = "Stats";

export const STRINGS_CREATE = "Create";
export const STRINGS_FILTER = "Filter";
export const STRINGS_SAVE = "Save";
export const STRINGS_DELETE = "Delete";
export const STRINGS_PREVIEW = "Preview";
export const STRINGS_ADD = "Add";
export const STRINGS_CATEGORY = "Category";
export const STRINGS_PRODUCT = "Product";
export const STRINGS_IMAGE = "Image";
export const STRINGS_TITLE = "Title";
export const STRINGS_EDIT_TITLE = "Edit Title";
export const STRINGS_EDIT_VALUE = "Edit Value";
export const STRINGS_EDIT = "Edit";
export const STRINGS_ATTACHMENT = "Attachment";
export const STRINGS_LOAD_MORE = "Load More";
export const STRINGS_DELETE_CATEGORY = "Delete Category";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY = "Are you sure you want to delete the category?";
export const STRINGS_DELETE_STORE = "Delete Store";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_STORE = "Are you sure you want to delete the store?";
export const STRINGS_DELETE_PRODUCT = "Delete Product";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_PRODUCT = "Are you sure you want to delete the product?";


export const STRINGS_404_NOT_FOUND = "404 Not Found";
